var map = {
	"./calendar.png": [
		89476,
		9476
	],
	"./covid-awareness.png": [
		89195,
		9195
	],
	"./covid.png": [
		62459,
		2459
	],
	"./directory.png": [
		93345,
		3345
	],
	"./document.png": [
		65749,
		5749
	],
	"./facts.png": [
		39145,
		9145
	],
	"./fb-group.png": [
		11060,
		1060
	],
	"./feed.png": [
		49322,
		9322
	],
	"./floor-map.png": [
		52775,
		2775
	],
	"./holidays.png": [
		77597,
		7597
	],
	"./horoscope.png": [
		90534,
		534
	],
	"./image.png": [
		82079,
		2079
	],
	"./instagram.png": [
		51056,
		1056
	],
	"./menu-1.png": [
		29005,
		9005
	],
	"./menu-2.png": [
		47382,
		7382
	],
	"./news.png": [
		13111,
		3111
	],
	"./photowall.png": [
		32672,
		2672
	],
	"./power-bi.png": [
		53013,
		3013
	],
	"./presentation.png": [
		47774,
		7774
	],
	"./quote.png": [
		34600,
		4600
	],
	"./review.png": [
		22438,
		2438
	],
	"./sale.png": [
		23695,
		3695
	],
	"./schedule.png": [
		3865,
		3865
	],
	"./slide-show.png": [
		2205,
		2205
	],
	"./social-activity.png": [
		42905,
		2905
	],
	"./social-feed.png": [
		522,
		522
	],
	"./social-linkedin.png": [
		34524,
		4524
	],
	"./social-photowall.png": [
		83104,
		3104
	],
	"./sport-news.png": [
		11936,
		1936
	],
	"./stream.png": [
		78678,
		8678
	],
	"./tasty.png": [
		19333,
		9333
	],
	"./ted.png": [
		94339,
		4339
	],
	"./text.png": [
		44059,
		4059
	],
	"./ticker.png": [
		52979,
		5360
	],
	"./tiktok.png": [
		42424,
		2424
	],
	"./trip-advisor.png": [
		76680,
		6680
	],
	"./twitter.png": [
		67709,
		7709
	],
	"./video.png": [
		92173,
		2173
	],
	"./weather.png": [
		54056,
		4056
	],
	"./website.png": [
		65655,
		5655
	],
	"./world-clock.png": [
		745,
		745
	],
	"./yelp.png": [
		11320,
		1320
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 26086;
module.exports = webpackAsyncContext;